(function (app) {
    app.provider("arcEnrollments", [function () {
        this.$get = ["arcEnrollmentsApi", function (arcEnrollmentsApi) {
            var service = {};

            return arcEnrollmentsApi.getAllArcEnrollments().then(function (response) {
                response.forEach(function (enrollment) {
                   
                    enrollment.Name = enrollment.Name.replace(/\s+/g, "");

                    enrollment.Name.match(/^([A-Z]*)[A-Z]/);

                    if (RegExp.$1.length)
                        enrollment.Name = enrollment.Name.replace(RegExp.$1, RegExp.$1.toLowerCase());
                    else
                        enrollment.Name =
                            enrollment.Name.charAt(0).toLowerCase() + enrollment.Name.slice(1);

                    service[enrollment.Name + "Id"] = enrollment.Id;
                });

                return service;
            });
        }];
    }]);
})(window.app); // jshint ignore:line